import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BitfInfiniteScrollTriggerComponent } from '../../bitf-infinite-scroll-trigger.component';

@Component({
  selector: 'bitf-mat-infinite-scroll-trigger',
  templateUrl: './bitf-mat-infinite-scroll-trigger.component.html',
  styleUrls: ['./bitf-mat-infinite-scroll-trigger.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BitfMatInfiniteScrollTriggerComponent extends BitfInfiniteScrollTriggerComponent {
  @Input() diameter = 30;
}
